"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.redirectExceptions = void 0;
var _homePageLayoutHelper = require("./homePageLayoutHelper");
var redirectExceptions = exports.redirectExceptions = function redirectExceptions() {
  if ((0, _homePageLayoutHelper.checkForConfirmWithdrawParam)()) return true;
  if ((0, _homePageLayoutHelper.checkForResetPassParam)()) return true;
};